import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import PageWithSidebar from 'components/PageWithSidebar';
import EntitySidebar from 'components/EntitySidebar';
import Tabber from 'components/Tabber';
import PoiEditForm from 'components/PoiEditForm';
import MediaEditor from 'components/MediaEditor';

import { withData } from 'lib';
import { ContentPoiEditPageQuery } from '__generated__/ContentPoiEditPageQuery.graphql';

const query = graphql`
  query ContentPoiEditPageQuery($id: ID!) {
    poi(id: $id) {
      name

      ...EntitySidebar_entity
      ...PoiEditForm_poi
      ...MediaEditor_mediable
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<ContentPoiEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/content', name: 'Turinys' },
  { link: '/content/pois', name: 'Lankytinos vietos' },
];

const ContentPoiEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { poi } = usePreloadedQuery<ContentPoiEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!poi) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<EntitySidebar entity={poi} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          name: poi.name,
        },
      ]}>
      <Tabber
        tabs={[
          {
            title: 'Bendra informacija',
            component: <PoiEditForm poi={poi} />,
            hash: 'main',
          },
          {
            title: 'Nuotrauka',
            component: <MediaEditor limit={1} mediable={poi} />,
            hash: 'media',
          },
        ]}
      />
    </PageWithSidebar>
  );
};

export default withData<ContentPoiEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(ContentPoiEditPage);
